import script from "./SuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessView.vue?vue&type=script&setup=true&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=05ed6dd0&lang=css"

const __exports__ = script;

export default __exports__